'use strict';

function LoanApplicationPhoneVerification() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$phoneVerification = $('#phone-verification');

    this._$phoneVerification.mogo().create('PhoneVerification', {
      onComplete: this._onCompletePhoneVerification.bind(this),
      presenter: this.presenter,
      analytics: this.analytics,
      prefill: true,
      summaryMode: true,
      onInit: this._onInitPhoneVerification.bind(this)
    }, 'page');

    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
    this._setupEventHandlers();
  };

  this._setupEventHandlers = function () {
    this._$prevBtn.on('click', function () {
      $('#LoanApplicationTray').mogo()._loanAppGoToPreviousStep();
    });

    this._$nextBtn.on('click', function () {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
    });
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._onCompletePhoneVerification = function () {
    this._$nextBtn.mogo().removeDisabledState();
  };

  /*
  setupNextBtnEvents: Disable the next button on start, user's should not be
  allowed to progress further without validating their phone number.
  */
  this._onInitPhoneVerification = function () {
    // Phone number is verified when account model has phone_number property
    if (this._$phoneVerification.mogo().isPhoneValidated() === false) this._$nextBtn.mogo().setDisabledState();
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this._super();
  };
}